import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { shadows } from '@doltech/ui/lib/figma/shadows';
import { ButtonIconPrimarySize } from '@doltech/ui/lib/figma/Button/ButtonIconPrimarySize/ButtonIconPrimarySize';
import { ButtonIconPrimaryStyles } from '@doltech/ui/lib/figma/Button/ButtonIconPrimaryStyles/ButtonIconPrimaryStyles';
import cl from 'classnames';
import { IconsArrowToTop } from '@doltech/icons/SystemV2/IconsArrowToTop';

const Container = styled.aside`
  position: fixed;
  bottom: 130px;
  right: 16px;
  background-color: ${colorsV2.white100};
  border-top: 1px solid ${colorsV2.gray20};
  border-radius: 40px;
  box-shadow: ${shadows.zIndex4};
  z-index: 10;

  opacity: 0;
  pointer-events: auto;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.visible {
    opacity: 1;
  }
`;

export const ScrollToTopButton = (props) => {
  const { visible } = props;
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Container className={cl({ visible })}>
      <ButtonIconPrimaryStyles
        color="white"
        buttonStyle="filled"
        colorStyle="bold"
        transparent
        content={
          <ButtonIconPrimarySize size="x-large" icon={<IconsArrowToTop size={24}/>}/>
        }
        onClick={scrollToTop}
      />
    </Container>
  );
};
// Components/Icons/Arrow/To top
